import component from './landing.vue'

export default component
